import * as _ from 'underscore';

import ACTIONS from '../actions';
import LIBRARY_ACTIONS from '../../library/actions';
import * as Utils from '../../../../lib/designerUtils';

const uiTree = (
    state = {
        autoPublishSettingsOpen: false,
        newExerciseDialog: false,
        deleteBlockDialog: false,
        deleteSessionDialog: false,
        blockLinkingKey: false,
        createSchemeDialog: false,
        newCircuitDialog: false,
        comboDialog: false,
        confirmDialog: false,
        saveSessionToLibraryDialog: false,
        exerciseCreated: false,
        exerciseSwapped: false,
        exerciseTags: [],
        schemeTags: [],
        schemeUpdated: false,
        showMoreVideos: false,
        calendarBlockNamesEnabled: false,
        calendarInstructionsEnabled: false,
        isLoading: false,
        tocLoading: false,
        drawerLoading: true,
        blockSaving: false,
        uiSaving: false,
        circuitsEnabled: [],
        blockSaved: [],
        circuitTypesSaved: {
            [Utils.BlockTypes.UNCATEGORIZED]: 1,
            [Utils.BlockTypes.PREP]: 1,
            [Utils.BlockTypes.SPEED_AGILITY]: 1,
            [Utils.BlockTypes.SKILL_TECH]: 1,
            [Utils.BlockTypes.STRENGTH_POWER]: 1,
            [Utils.BlockTypes.CONDITIONING]: 1,
            [Utils.BlockTypes.RECOVERY]: 1,
            [Utils.BlockTypes.SURVEY]: 1,
            [Utils.BlockTypes.BIOMETRIC]: 1
        },
        drawerDialogs: {
            calendar: false,
            program: false,
            session: false,
            item: {},
            inform: {
                title: '',
                open: false
            }
        },
        selectedSessionIds: [],
        tags: [],
        calendarExtraViewOptions: []
    },
    action
) => {
    let tags = [];
    let exerciseTags = [];
    let schemeTags = [];

    switch (action.type) {
        case ACTIONS.NUTRITION_LOADING:
            return {
                ...state,
                nutritionLoading: true,
                nutritionLoadedForDate: undefined
            };
        case ACTIONS.NUTRITION_LOADED:
            return {
                ...state,
                nutritionLoading: false
            };
        case ACTIONS.UI_MORE_VIDEOS:
            return {
                ...state,
                showMoreVideos: action.showMoreVideos
            };
        case ACTIONS.CALENDAR_OPEN_AUTOPUBLISH_SETTINGS:
            return {
                ...state,
                autoPublishSettingsOpen: !state.autoPublishSettingsOpen
            };
        case ACTIONS.UI_CALENDAR_SESSION_EDIT_URL:
            return {
                ...state,
                designerUrl: action.designerUrl
            };
        case ACTIONS.UI_CALENDAR_SESSION_SCROLL_KEY:
            return {
                ...state,
                designerScrollKey: action.designerScrollKey
            };
        case ACTIONS.CONFIRM_DIALOG_VALUE:
            const isOk = action.isOk;
            return {
                ...state,
                isOk
            };
        case ACTIONS.UI_BASIC_DRAWER:
            return {
                ...state,
                drawerOpen: !action.drawerOpen
            };
        case ACTIONS.UI_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            };
        case ACTIONS.SET_CURRENT_DAY:
            return {
                ...state,
                currentDay: action.currentDay
            };
        case ACTIONS.DAYS_RELOAD:
            return {
                ...state
            };
        case ACTIONS.UI_NEW_DIALOG:
            var newState = {
                ...state,
                newExerciseDialog: action.isOpen,
                createNew: action.createNew,
                clearTags: action.clearTags
            };

            if (action.isOpen) {
                newState.setExercise = action.setExercise;
                newState.block = action.block;
            }

            return newState;
        case ACTIONS.UI_COMBO_EDIT_DIALOG:
            newState = {
                ...state,
                comboDialog: action.isOpen,
                clearTags: action.clearTags
            };

            if (action.isOpen) {
                newState.combo = action.combo;
            }

            return newState;
        case ACTIONS.UI_CIRCUIT_DIALOG:
            newState = {
                ...state,
                newCircuitDialog: action.isOpen,
                newCircuitTitle: Utils.getBlockTypeText(action.block),
                editCircuit: action.edit
            };

            if (action.isOpen) {
                newState.block = action.block;
            }

            return newState;
        case ACTIONS.UI_SAVE_SESSION_TO_LIBRARY_DIALOG:
            newState = {
                ...state,
                saveSessionToLibraryDialog: action.saveSessionToLibraryDialog,
                session: action.session
            };
            return newState;
        case ACTIONS.EXERCISES_BENCHMARK_REF_ADD:
            const newCircuitTypesSaved = { ...state.circuitTypesSaved };
            if (state.block && state.block.type) {
                const blockType = state.block.type;
                newCircuitTypesSaved[blockType] = ++newCircuitTypesSaved[
                    blockType
                ];
            }

            return {
                ...state,
                circuitTypesSaved: newCircuitTypesSaved
            };
        case ACTIONS.CALENDAR_SET_TEAM:
            return {
                ...state,
                isPubEnabled: action.team.pub_enabled === 1
            };
        case ACTIONS.UI_SCHEME_DIALOG:
            newState = {
                ...state,
                createSchemeDialog: action.isOpen,
                clearTags: action.clearTags
            };

            if (action.isOpen) {
                newState.exercise = action.exercise;
                newState.abr = action.abr;
            }

            return newState;
        case ACTIONS.UI_DELETE_DIALOG:
            newState = {
                ...state,
                deleteBlockDialog: action.isOpen,
                deleteBlockBind: action.bind,
                session: action.session,
                exercise: action.exercise,
                day: action.day
            };

            if (action.block) {
                newState.block = action.block;
            }

            return newState;
        case ACTIONS.UI_SAVING:
            return {
                ...state,
                uiSaving: action.uiSaving
            };
        case ACTIONS.UI_SCROLL_TO_BLOCK:
            return {
                ...state,
                scrollKey: action.key
            };
        case ACTIONS.UI_SCROLL_TO_EXERCISE:
            return {
                ...state,
                scrollKey: action.key
            };
        case ACTIONS.UI_DRAWER_LOADING:
            return {
                ...state,
                drawerLoading: action.drawerLoading
            };
        case ACTIONS.UI_PAGE_TITLE:
            return {
                ...state,
                pageTitle: action.pageTitle
            };
        case ACTIONS.UI_BLOCK_EDITING:
            return {
                ...state,
                blockEditingKey: action.blockKey,
                blockFocusedKey: false
            };
        case ACTIONS.UI_BLOCK_LINKING:
            return {
                ...state,
                blockLinkingKey: action.blockKey
            };
        case ACTIONS.UI_BLOCK_FOCUS:
            return {
                ...state,
                blockFocusedKey: action.blockKey,
                blockEditingKey: false
            };
        case ACTIONS.EXERCISE_TAGS_LOAD:
            let tags = [...action.tags, ...state.tags];
            tags = _.uniq(tags, tag => tag.id);
            tags = _.sortBy(tags, 'title');

            schemeTags = _.filter(tags, tag => parseInt(tag.type) === 4);
            schemeTags = _.uniq(schemeTags, tag => tag.title.toLowerCase());
            exerciseTags = _.filter(tags, tag => parseInt(tag.type) === 3);
            exerciseTags = _.uniq(exerciseTags, tag => tag.title.toLowerCase());

            return {
                ...state,
                tags,
                exerciseTags,
                schemeTags
            };
        case ACTIONS.UI_HOVER_DAY:
            return {
                ...state,
                currentDay: action.date
            };
        case ACTIONS.UI_CALENDAR_DAY_HOVER:
            return {
                ...state,
                calendarHover: action.dayKey
            };
        case ACTIONS.UI_CALENDAR_DAY_SELECT:
            return {
                ...state,
                selectedDay: action.day
            };
        case ACTIONS.UI_CREATE_TAG:
            tags = state.tags;
            tags.push(action.tag);
            _.sortBy(tags, 'title');
            schemeTags = _.filter(tags, tag => parseInt(tag.type) === 4);
            exerciseTags = _.filter(tags, tag => parseInt(tag.type) === 3);

            return {
                ...state,
                clearTags: false,
                newTag: action.tag,
                tags,
                schemeTags,
                exerciseTags
            };
        case ACTIONS.UI_ENABLE_CIRCUIT_SAVE:
            const newstate = {
                ...state
            };
            if (action.enableCircuitSave) {
                if (newstate.circuitsEnabled.indexOf(action.block.id) < 0) {
                    newstate.circuitsEnabled.push(action.block.id);
                }
            } else {
                const index = newstate.circuitsEnabled.indexOf(action.block.id);
                newstate.circuitsEnabled.splice(index, 1);
            }
            return newstate;
        case ACTIONS.BLOCK_ADD_EXERCISE:
            const linked = action.linked || action.isSuperset;
            return {
                ...state,
                exerciseCreated: linked ? false : action.block.key,
                exerciseSwapped: false
            };
        case ACTIONS.BLOCK_SWAP_EXERCISE:
            return {
                ...state,
                exerciseSwapped: action.exercise.key,
                exerciseCreated: false
            };
        case ACTIONS.BLOCK_UPDATE:
            return {
                ...state,
                newExercise: action.newExercise || false
            };
        case ACTIONS.SET_CURRENT_BLOCK:
            return {
                ...state,
                block: action.block
            };
        case ACTIONS.BLOCK_UPDATE_EXERCISE_IDS:
            return {
                ...state,
                exerciseSwapped: false,
                exerciseCreated: false,
                schemeUpdated: false
            };
        case ACTIONS.SCHEME_UPDATE:
            return {
                ...state,
                schemeUpdated: action.custom ? action.exercise.key : false
            };
        case ACTIONS.UI_PREVIEW:
            return {
                ...state,
                previewedItem: action.item,
                previewPosition: action.previewPosition
            };
        case ACTIONS.UI_CONFIRM_DIALOG:
            return {
                ...state,
                confirmDialog: action.confirmDialog,
                confirmTitle: action.confirmTitle,
                confirmCb: action.confirmCb
            };
        case ACTIONS.UI_SUPERSET_SAVE_DIALOG:
            return {
                ...state,
                supersetDialog: action.supersetDialog,
                block: action.block
            };
        case ACTIONS.UI_CALENDAR_SIDENAV:
            return {
                ...state,
                calendarSideNavOpen: action.calendarSideNavOpen
            };
        case ACTIONS.UI_ADD_DRAWER_DIALOG:
            return {
                ...state,
                drawerDialogs: {
                    ...state.drawerDialogs,
                    item: action.item,
                    totalDays: parseInt(action.totalDays),
                    [action.dialogType]: action.open
                }
            };
        case ACTIONS.UI_INFORM:
            return {
                ...state,
                drawerDialogs: {
                    ...state.drawerDialogs,
                    inform: {
                        open: action.open,
                        title: action.title,
                        message: action.message
                    }
                }
            };
        case ACTIONS.UI_BLOCK_SAVING:
            return {
                ...state,
                blockSaving: action.isSaving ? action.block.key : false
            };
        case ACTIONS.UI_BLOCK_SAVED:
            const ns = { ...state };
            const found = state.blockSaved.indexOf(action.blockSaved);
            if (action.save) {
                ns.blockSaved.push(action.blockSaved);
            } else if (found >= 0 && !action.save) {
                ns.blockSaved.splice(found, 1);
            }
            return ns;
        case ACTIONS.UI_TOC_LOADING:
            return {
                ...state,
                tocLoading: action.loading
            };
        case ACTIONS.UI_MEGADROP_OPEN:
            return {
                ...state,
                block: action.block,
                session: action.session
            };
        case ACTIONS.CALENDAR_EXTRA_DATA:
            return {
                ...state,
                extraWorkData: action.extraWork
            };
        case ACTIONS.CALENDAR_ATHLETE_INFO:
            return {
                ...state,
                currentUser: action.currentUser
            };
        case ACTIONS.CALENDAR_PROGRAMS_LOAD:
            return {
                ...state,
                drawerLoading: false
            };
        case LIBRARY_ACTIONS.UI_RELOAD_DRAWER:
            return {
                ...state,
                drawerLoading: true
            };
        case ACTIONS.UI_SET_TOOLTIP_CONTENT:
            return {
                ...state,
                tooltipContent: { ...action.content }
            };
        case ACTIONS.UI_UPDATE_TOOLTIP_CONTENT:
            if (
                state.tooltipContent &&
                state.tooltipContent.id === action.content.id
            ) {
                return {
                    ...state,
                    tooltipContent: { ...action.content }
                };
            }
            return state;

        case ACTIONS.CALENDAR_SESSION_SELECT:
            return {
                ...state,
                selectedSessionIds: action.itemIds
            };
        case ACTIONS.UI_CALENDAR_DRAGGING:
            return {
                ...state,
                isDragging: action.isDragging
            };
        case ACTIONS.CALENDAR_TOGGLE_INSTRUCTIONS:
            return {
                ...state,
                calendarInstructionsEnabled: !state.calendarInstructionsEnabled
            };
        case ACTIONS.CALENDAR_TOGGLE_BLOCK_NAMES:
            return {
                ...state,
                calendarBlockNamesEnabled: !state.calendarBlockNamesEnabled
            };
        case ACTIONS.SET_SELECTED_DATE:
            return {
                ...state,
                selectedDate: action.date
            };
        case ACTIONS.CALENDAR_EXTRA_VIEW_OPTIONS:
            var enabled = [];
            if (action.viewOptions) {
                Object.keys(action.viewOptions).forEach(key => {
                    const item = key.split('-');
                    if (!action.viewOptions[key]) {
                        enabled.push(parseInt(item[1]));
                    }
                });
            }

            return {
                ...state,
                calendarExtraViewOptions: [...enabled]
            };
        default:
            return state;
    }
};

export default uiTree;



// WEBPACK FOOTER //
// ./src/state/reducer/calendar/reducer/uiTree.js